import {MODAL_TYPE, showModal} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import {REPORT_TYPE} from '../../../constants';
import type {
	Person,
	ReportShare,
} from '../../../forecast-app/reports-tab/reports-page/actions/share-report/ShareReportModalTypes';

export interface BuilderShareDialogInput {
	/** The Reports-list entry to share. A draft has none and must not reach here. */
	reportId: string;
	shares: ReportShare[];
	reportOwner: Person;
	privateAccess: boolean;
	/** Notified with the report's new privacy value once the dialog's "share with company" toggle
	 * commits, so the builder's saved-report state stays current for the next `save()`. */
	onPrivateAccessChange?: (privateAccess: boolean) => void;
	/** Resolves a Forecast person for a share's email, so a share added while the dialog is open
	 * renders the same avatar/name block as a share that was already present when it opened. */
	resolvePerson?: (email: string) => Person | undefined;
}

/** Opens the shared report-sharing dialog with the viewer/editor role control turned on. The dialog
 * itself is the same one the Reports list uses; only this entry point asks for roles. */
export const openBuilderShareDialog = ({
	reportId,
	shares,
	reportOwner,
	privateAccess,
	onPrivateAccessChange,
	resolvePerson,
}: BuilderShareDialogInput): void => {
	showModal({
		type: MODAL_TYPE.SHARE_REPORT_MODAL,
		reportId,
		reportSharesInput: shares,
		privateAccessInput: privateAccess,
		reportOwner,
		reportType: REPORT_TYPE.TASK_REPORT,
		enableEditorRoles: true,
		onPrivateAccessChange,
		resolvePerson,
	});
};
